import {enConfig} from './en';

export const cnConfig = {
    ...enConfig.base,
    bismi:'以真主的名义，至仁至',
    salaam:'愿你平安',
    header:{
        signup : "注册",
        signin : "登录",    
        signout : "退出",
        close: "关闭",
        profile: "个人资料",
        about : "关于",
        article : "文章",
        contact : "联系",
        download: "下载",
        joinus : "加入我们",    
        email: "电子邮件",
        phone: "电话"
    },
    
    home:{
        title : '数字化',
        about: '我们旨在向新一代介绍数字职业和编程语言，特别是Python和Js',
        connected: '您必须注册'
    },

    blog: {
        ...enConfig.blog,
        title :'最有趣的文章',
    },

    contact:{
        title:'联系我们',
        message:'请填写下面的表格给我们发送电子邮件',
        confirm:'联系确认',
        content:'请填写我们通过电子邮件发送给您的代码以确认它',
        recipient:"请确认收件人的信息。",
        feedback : '我们已收到您的消息，我们会尽快回复您',
        warning : "需要在继续之前确认您的电子邮件"
    },

    getApp : {
        name : '下载服务应用程序',
        info : '下载服务应用程序'
    },

}
